import React from 'react';
import { LucideIcon } from 'lucide-react';
import BookmarkButton from './BookmarkButton';
import ShareButton from './ShareButton';
import { useLocation } from 'react-router-dom';

interface CalculatorProps {
  title: string;
  description: string;
  icon: LucideIcon;
  children: React.ReactNode;
  result?: string;
}

const Calculator: React.FC<CalculatorProps> = ({ title, description, icon: Icon, children, result }) => {
  const location = useLocation();

  return (
    <div className="max-w-4xl mx-auto">
      {/* NOTE: no <SEOHead> here. Each page owns its own head. A page-level
          SEOHead keyed by the URL slug previously resolved to the home default
          (slugs don't match seoMetadata keys) and, rendering after the page's
          own SEOHead, overwrote every calculator page's title and canonical
          with the homepage's — making every page look like a homepage duplicate. */}
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <Icon className="h-10 w-10 text-blue-600 mr-4" />
            <div>
              <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
              <p className="text-gray-600 mt-1">{description}</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <ShareButton 
              title={title}
              path={location.pathname}
              result={result}
            />
            <BookmarkButton path={location.pathname} title={title} />
          </div>
        </div>
        <div className="border-t border-gray-200 pt-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Calculator;